<template>
  <div id="js-welfare-content" :class="$style.welfare">
    <div class="app-fadeInUp">
      <the-welfare-list />
    </div>
  </div>
</template>

<script>
import fadeMixins from '@/assets/js/fadeMixins'
import TheWelfareList from './TheWelfareList'

export default {
  components: { TheWelfareList },
  mixins: [fadeMixins],
  data() {
    return {
      name: 'welfare',
      animateScenesData: ['content'],
    }
  },
}
</script>

<style lang="less" module>
.welfare {
  padding: @padding-base 0;
}
</style>
